import { Directive, Input } from '@angular/core';

@Directive({
  standalone: true,
  selector: 'ng-template[templateType]', // eslint-disable-line @angular-eslint/directive-selector
})
export class TemplateTypeDirective<T> {
  @Input('templateType') templateType: T; // eslint-disable-line @angular-eslint/no-input-rename

  static ngTemplateContextGuard<T>(dir: TemplateTypeDirective<T>, ctx: unknown): ctx is T {
    return true;
  }
}